import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceContactPerson = ({ blok }) => (
  <div className="flex justify-center" {...storyblokEditable(blok)}>
    <div className="service-contact-wrap flex flex-col justify-center">
      <div className="service-contact-left flex flex-col">
        <h2 className="text-2xl">{blok.subheadline}</h2>
        <span>{blok.name}</span>
      </div>
      <div className="service-contact-right flex flex-col justify-center">
        <div className="flex pb-2 pt-2 items-center">
          <a href={`tel:${blok.number}`}>
            {" "}
            <img src={blok.image.filename} alt={blok.image.alt} />
          </a>
          <a href={`tel:${blok.number}`}>
            <span>{blok.number}</span>
          </a>
        </div>
        <div className="flex  items-center">
          <a className="cursor-pointer" href={`mailto:${blok.mailaddress}`}>
            <img src={blok.mailimage.filename} alt={blok.image.alt} />
          </a>
          <a className="cursor-pointer" href={`mailto:${blok.mailaddress}`}>
            <span>{blok.mailaddress}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default ServiceContactPerson;
